<div class="snackbar-wrapper">
  <!-- <button class="snackbar-wrapper__close-btn">
    <icon set="lucide" name="x" size="14" />
  </button> -->

  <a
    href="{{ getNotificationUrl() }}"
    target="_blank"
    (click)="performAction($event)"
  >
    <div class="snackbar-container">
      <div class="snackbar-container__icon-wrapper">
        <div class="snackbar-container__icon-inner">
          <icon name="info-large" />
        </div>
      </div>
      <p
        class="snackbar-container__desc"
        [innerHtml]="notification.content.message"
      ></p>
    </div>
  </a>
</div>
